import { oidcConfig } from "../../OidcConfig";
const Logout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    const clientId = oidcConfig.client_id;
    const logoutUri = oidcConfig.logout_uri;
    const cognitoDomain = oidcConfig.cdomain;
    const url = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}&federated`;
    window.location.href = url;
  };
export default Logout;